type MedOrRecStore = { recreational?: boolean };

export const ensureOneMedicalAndRecreationalStore = <T extends MedOrRecStore>(
  stores: T[] = []
): T[] =>
  stores.reduce<T[]>(
    (prev, curr) =>
      !prev.find((store) => store.recreational === curr.recreational)
        ? [...prev, curr]
        : prev,
    []
  );
